import { Component, OnInit } from '@angular/core';
import { Student } from './Models/student';
import { Router }            from '@angular/router';
import { StudentService } from './Service/student.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {

}



// WEBPACK FOOTER //
// /home/hihoo/ibilling/attendence/public/src/app/app.component.ts